import colors from '../colors';
import Button, { ButtonWrapper } from './Button';
import * as React from 'react';
import styled, { css, StyledFunction } from 'styled-components';
import Message from './Message';

export default class WarningButton extends Button {
    render() {
        return (
            <WarningButtonWrapper
                onClick={this.handleClick}
                type="button"
                primary={this.props.primary}
            >
                {this.props.children}
            </WarningButtonWrapper>
        );
    }
}

const WarningButtonWrapper = ButtonWrapper.extend`
    border: 1px solid ${props => props.theme.warningButton.fgColor};
    color: ${props => props.theme.warningButton.fgColor};
    text-transform: none;
    &:hover,
    &:focus {
        color: ${props => props.theme.warningButton.fgColor};
        border: 1px solid ${props => props.theme.warningButton.fgColor};
    }
    ${props =>
        props.primary &&
        css`
            border: 1px solid ${props => props.theme.warningButton.primaryBgColor};
            background: ${props => props.theme.warningButton.primaryBgColor};
            color: ${props => props.theme.warningButton.primaryFgColor};
            &:hover,
            &:focus {
                color: ${props => props.theme.warningButton.primaryFgColor};
                border: 1px solid ${props => props.theme.warningButton.primaryBgColor};
            }
        `};
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/WarningButton.tsx